import { observer } from 'mobx-react-lite';
import { Title } from '../../../../components/display';
import { CheckboxField } from '../../../../components/form';
import PulseKeySearch from '../../store/PulseKeySearch';

export default observer(function Columns({
  controlWidth = 240,
  search,
}: {
  controlWidth?: number;
  search: PulseKeySearch;
}) {
  return (
    <>
      <Title sx={{ mb: 0 }}>Columns</Title>
      <CheckboxField
        label="Status"
        name="columns.status"
        onChange={search.handleChange}
        sx={{ mt: 0, width: controlWidth }}
        value={search.columns.status}
      />
      <CheckboxField
        label="SKU"
        name="columns.sku"
        onChange={search.handleChange}
        sx={{ mt: 0, width: controlWidth }}
        value={search.columns.sku}
      />
      <CheckboxField
        label="Label"
        name="columns.label"
        onChange={search.handleChange}
        sx={{ mt: 0, width: controlWidth }}
        value={search.columns.label}
      />
      <CheckboxField
        label="Number of Downloads"
        name="columns.downloadCount"
        onChange={search.handleChange}
        sx={{ mt: 0, width: controlWidth }}
        value={search.columns.downloadCount}
      />
      <CheckboxField
        label="IP of redemption"
        name="columns.redemptionIp"
        onChange={search.handleChange}
        sx={{ mt: 0, width: controlWidth }}
        value={search.columns.redemptionIp}
      />
      <CheckboxField
        label="IP of download"
        name="columns.ipOfDownload"
        onChange={search.handleChange}
        sx={{ mt: 0, width: controlWidth }}
        value={search.columns.ipOfDownload}
      />
      <CheckboxField
        label="Sent date"
        name="columns.fulfilledAt"
        onChange={search.handleChange}
        sx={{ mt: 0, width: controlWidth }}
        value={search.columns.fulfilledAt}
      />
      <CheckboxField
        label="Creation date"
        name="columns.createdAt"
        onChange={search.handleChange}
        sx={{ mt: 0, width: controlWidth }}
        value={search.columns.createdAt}
      />
    </>
  );
});
